//user consts
export const SET_ETH_ADDRESS = 'SET_ETH_ADDRESS';
export const LOG_OUT = 'LOG_OUT';
export const LOG_IN = 'LOG_IN ';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_BOX = 'SET_BOX';
export const SET_DAPP = 'SET_DAPP';
export const SET_USER_POSTS = 'SET_USER_POSTS';

//posts consts
export const SET_CURRENT_RESULT = 'SET_CURRENT_RESULT';
export const SET_IPFS_POSTS = 'SET_IPFS_POSTS';
export const SET_CONTRACT = 'SET_CONTRACT';

//ui
export const TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN';
export const TOGGLE_ADD_IMAGE = 'TOGGLE_ADD_IMAGE';
export const START_LOADING_SCREEN = 'START_LOADING_SCREEN';
export const END_LOADING_SCREEN = 'END_LOADING_SCREEN';
export const RESET_STATE = 'RESET_STATE';